import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import TableCellDescription from "ds/components/Table/Row/CellDescription";
import { FlowsProjectRoleBindingView } from "shared/Flows/Projects/useFlowsProject/types";

const FlowsProjectDetailsRolesDescriptionCell = ({
  item: roleBinding,
  ...cellProps
}: TableSimpleCellProps<FlowsProjectRoleBindingView>) => {
  return (
    <TableSimpleCell {...cellProps}>
      <TableCellDescription description={roleBinding.role.description} />
    </TableSimpleCell>
  );
};

export default FlowsProjectDetailsRolesDescriptionCell;
